module.exports = __webpack_public_path__ + "img/b013_2.574e4649.jpeg";